var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePictureShowHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5003 32.0833C25.5545 32.0833 32.0837 25.5541 32.0837 17.5C32.0837 9.44584 25.5545 2.91666 17.5003 2.91666C9.44617 2.91666 2.91699 9.44584 2.91699 17.5C2.91699 25.5541 9.44617 32.0833 17.5003 32.0833Z",
    stroke: "white",
    strokeWidth: 1.5625
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 24.7917C14.3379 21.2301 20.6255 21.0624 24.0625 24.7917M21.1387 13.8542C21.1387 15.8677 19.504 17.5 17.4876 17.5C15.4713 17.5 13.8366 15.8677 13.8366 13.8542C13.8366 11.8406 15.4713 10.2083 17.4876 10.2083C19.504 10.2083 21.1387 11.8406 21.1387 13.8542Z",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePictureShowHide);
export default __webpack_public_path__ + "static/media/ProfilePictureShowHide.bc933b33b907259f61d14a2c3e0eef01.svg";
export { ForwardRef as ReactComponent };